import { render, staticRenderFns } from "./SettingOrders.vue?vue&type=template&id=4584b4a2"
import script from "./SettingOrders.vue?vue&type=script&lang=js"
export * from "./SettingOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports